import { useTranslation } from 'react-i18next';
import ConfirmDialog from '../ui/ConfirmDialog';

type ConfirmDeleteModalProps = {
  open: boolean;
  title: string;
  entityLabel: string;
  entityName: string;
  deleting?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function ConfirmDeleteModal({
  open,
  title,
  entityLabel,
  entityName,
  deleting = false,
  onCancel,
  onConfirm,
}: ConfirmDeleteModalProps) {
  const { t } = useTranslation();

  return (
    <ConfirmDialog
      isOpen={open}
      title={title}
      message={t('confirmDelete.messageWithEntity', { entityLabel, entityName })}
      cancelLabel={t('common.cancel')}
      confirmLabel={deleting ? t('common.deleting') : t('common.delete')}
      confirmDisabled={deleting}
      confirmVariant="danger"
      onClose={() => {
        if (!deleting) onCancel();
      }}
      onConfirm={onConfirm}
    />
  );
}
